module.exports = __webpack_public_path__ + "img/trusted-health-patagonia-jacket.7d55847a.svg";